<template>
    <div class="print-page">
        <h2>{{ data.title }}</h2>
        <br/>
        <p class="al-center">（此表一式两份，一份由复筛机构留存，一份交家长）</p>
        <br/>
        <div class="d-flex justify-center">
            <h3>编号</h3>
            <input class="squ ml-ns" type="text" readonly :value="it" v-for="it in user.serialNumber"/>
        </div>
        <br/>
        <br/>
        <div class="d-flex justify-center" style="width: 70%; margin: auto; font-size: 18px; font-weight: bold;">
            <span>儿童姓名</span>
            <p class="d-flex-item" style="flex: 2;"><input class="line" type="text" readonly :value="user.name"/></p>
            <span>性别</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$common.sex.find(e => e.value === user.sex).text"/></p>
            <span>出生日期</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('YYYY')"/></p>
            <span>年</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('MM')"/></p>
            <span>月</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('DD')"/></p>
            <span>日</span>
        </div>
        <br/>
        <table border>
            <tr>
                <th rowspan="2" width="160">病史询问</th>
                <td>包括儿童生长发育史、现病史、既往史、父母孕育史、家族史等</td>
            </tr>
            <tr>
                <td>
                    <span class="mask" v-if="data.edited === 1"/>
                    <textarea rows="3" v-model="data.medicalHistory"/>
                </td>
            </tr>
            <tr>
                <th rowspan="2">行为观察</th>
                <td>以对儿童的行为观察为主，重点观察儿童社会交往、语言和非语言交流</td>
            </tr>
            <tr>
                <td>
                    <span class="mask" v-if="data.edited === 1"/>
                    <textarea rows="3" v-model="data.behavioralObservation"/>
                </td>
            </tr>
            <tr>
                <th>体格检查及神经系统检查</th>
                <td>
                    <span class="mask" v-if="data.edited === 1"/>
                    <textarea rows="3" v-model="data.physicalNeuroCheck"/>
                </td>
            </tr>
            <tr>
                <th rowspan="2">量表评估</th>
                <!-- ＜ 30分（非孤独症）≥ 30分（孤独症） -->
                <td>CARS量表：{{ data.carsScore }}分（{{ data.carsScore < 30 ? '非孤独症' : '孤独症' }}）</td>
            </tr>
            <tr>
                <td><span class="mask" v-if="data.edited === 1"/> 其他量表 <input class="line" type="text" v-model="data.otherScale" style="display: inline-block; width: 88%;"/></td>
            </tr>
            <tr>
                <th>辅助检查</th>
                <td>
                    <span class="mask" v-if="data.edited === 1"/>
                    <textarea rows="3" v-model="data.examinations"/>
                </td>
            </tr>
            <tr>
                <th>诊断结果</th>
                <td>
                    <div class="d-block">
                        <span class="mask"/>
                        <ul>
                            <li><input type="checkbox" :checked="data.result === 0 ? true : false" @click="data.result = 0"/> 排除孤独症</li>
                            <li><input type="checkbox" :checked="data.result === 1 ? true : false" @click="data.result = 1"/> 确诊孤独症</li>
                            <li><input type="checkbox" :checked="data.result === 2 ? true : false" @click="data.result = 2"/> 未确诊，2个月后复查</li>
                        </ul>
                    </div>
                    <div class="d-block">
                        <span class="mask" v-if="data.edited === 1"/>
                        <p class="mt-sm"><b>共患疾病</b>（注意缺陷多动障碍、抽动障碍、癫痫、强迫症等）</p>
                        <ul>
                            <li><input type="checkbox" :checked="data.comorbidities === '1' ? true : false" @click="data.comorbidities = '1'"/> 无</li>
                            <li><input type="checkbox" :checked="data.comorbidities === '2' ? true : false" @click="data.comorbidities = '2'"/> 有，请注明 <input class="line" type="text" :readonly="data.comorbidities === '1' ? true : false" v-model="data.comorbiditiesText" style="display: inline-block; width: 82%;"/></li>
                        </ul>
                    </div>
                </td>
            </tr>
            <tr>
                <th>确诊孤独症儿童干预康复建议</th>
                <td>
                    <span class="mask" v-if="data.edited === 1"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.recoveryAdvice1 === 1 ? true : false" @click="set_recoveryAdvice(1)"/> 家庭干预</li>
                        <li><input type="checkbox" :checked="data.recoveryAdvice2 === 1 ? true : false" @click="set_recoveryAdvice(2)"/> 社区干预（基层医疗卫生机构）</li>
                        <li><input type="checkbox" :checked="data.recoveryAdvice3 === 1 ? true : false" @click="set_recoveryAdvice(3)"/> 机构干预</li>
                        <li><input type="checkbox" :checked="data.recoveryAdvice4 === 1 ? true : false" @click="set_recoveryAdvice(4)"/> 其他，请说明<input class="line" type="text" :readonly="data.recoveryAdvice4 === 0 ? true : false" v-model="data.recoveryAdvice5" style="display: inline-block; width: 81%;"/></li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>填写日期</th>
                <td>
                    <div class="d-flex mt-xs width-50">
                        <input class="d-flex-item line" type="text" readonly :value="$moment(new Date()).format('YYYY')"/>
                        <span>年</span>
                        <input class="d-flex-item line" type="text" readonly :value="$moment(new Date()).format('MM')"/>
                        <span>月</span>
                        <input class="d-flex-item line" type="text" readonly :value="$moment(new Date()).format('DD')"/>
                        <span>日</span>
                    </div>
                </td>
            </tr>
            <tr>
                <th>医生签字</th>
                <td>
                    <input class="line" type="text"/>
                </td>
            </tr>
            <tr>
                <th>医疗机构</th>
                <td>
                    <input class="line" type="text"/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Object,
            user: Object,
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('诊断记录表------------->', this.data, this.user);
        },
        async mounted() {},
        methods: {
            async set_recoveryAdvice(d){
                if (d === 1){
                    this.data.recoveryAdvice1 = (this.data.recoveryAdvice1 === 0 ? 1 : 0);
                }
                if (d === 2){
                    this.data.recoveryAdvice2 = (this.data.recoveryAdvice2 === 0 ? 1 : 0);
                }
                if (d === 3){
                    this.data.recoveryAdvice3 = (this.data.recoveryAdvice3 === 0 ? 1 : 0);
                }
                if (d === 4){
                    this.data.recoveryAdvice4 = (this.data.recoveryAdvice4 === 0 ? 1 : 0);
                    if (this.data.recoveryAdvice4 === 0){
                        this.data.recoveryAdvice5 = '';
                    }
                }
                await this.$store.commit("initPrintFormData", this.data);
                await this.$forceUpdate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/zhenduan.vue